import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, onLoad = false, className = "" }) => {
  const trigger = onLoad
    ? { initial: "hide", animate: "show" }
    : { initial: "hide", whileInView: "show", viewport: { once: true, amount: 0.6 } };
  return (
    <motion.span
      className={`block overflow-hidden pb-[0.08em] -mb-[0.08em] ${className}`}
      variants={{ hide: {}, show: {} }}
      {...trigger}
    >
      <motion.span
        className="block will-change-transform"
        variants={{ hide: { y: "115%" }, show: { y: 0 } }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const SectionHead = ({ eyebrow, title, sub, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"}>
    <FadeUp>
      <p className="eyebrow flex items-center gap-3">
        {align !== "center" && <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />}
        {eyebrow}
      </p>
    </FadeUp>
    <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-ivory">
      {title}
    </h2>
    {sub && <p className="mt-5 text-mute text-base sm:text-lg leading-relaxed">{sub}</p>}
  </div>
);
